(function componentForm($, Adzuki)
{
	"use strict";

	var form = {
			name: 'ReservationGenerateDataSheet',
		},
		$iframe;

	$(document).ready(function documentReady()
	{
		Adzuki.onload('/Reservations/generateDataSheet', function onload() {
			$iframe = $('iframe#datasheet-preview');
			Adzuki.Form.registerForm(form);
		});
	});

	form.load = function load()
	{
		var $form          = $('form[name="'+form.name+'"]'),
		    $form_action   = $('#reservationgeneratedatasheet-action', $form);

		// BUTTANZ!
		$('.btn.submit', $form).on('click', function submitFormAction(e) {
			var $self  = $(this),
			    action = $self.data('action');

			e.preventDefault();
			$('.btn.submit', $form).addClass('disabled');

			$form_action.val(action);
			$form.submit();

			// artificial rate limiting for the download pdf button
			if (action === 'download') {
				$self.removeClass('submit');
				setTimeout(function enableDL() {
					$self.removeClass('disabled').addClass('submit');
				}, 10 * 1000);
			}
		});

		// cookie-based persistent toggleable sections
		Adzuki.ToggleableSection('[data-toggle="collapse"][data-cookie]');

		// auto-generate a preview so there's not a huge blank space on initial pageload
		$('.btn.btn-primary[data-action="generate-preview"]').click();
	};

	form.success = function success(data)
	{
		switch (data.status)
		{
			case 'generate-preview':
				$iframe.prop('src', data.data);
			break;

			case 'print':
				// for fucks sake, IE11...even Edge works correctly (a miracle in it's own right).
				// the other browsers print stuff is in the iframe itself.
				$iframe.on('load', function fuckIE11() {
					if (navigator.userAgent.toLowerCase().indexOf("trident") !== -1) {
						document.getElementById('datasheet-preview-iframe').contentWindow.document.execCommand('print', false, null);
					}
				});

				$iframe.prop('src', data.data);
			break;

			case 'download':
				window.location.href = data.data;
			break;

			default:
				Adzuki.StatusMessage('error', 'Unknown response');
			break;
		}

		$('.btn.submit.disabled').removeClass('disabled');
	};

}(jQuery, window.Adzuki || {}));
